import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'

const styles = theme => ({
  checked: {
    color: theme.palette.secondary.dark,
    '& + $bar': {
      backgroundColor: theme.palette.secondary.dark
    }
  },
  bar: {},
  colorPrimary: {
    backgroundColor: theme.palette.primary.light
  }
})
export default withStyles(styles)(
  class SwitchToolbarComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      checked: PropTypes.bool,
      label: PropTypes.string,
      onChange: PropTypes.func.isRequired
    }

    handleEditModeChange = (e, value) => {
      this.props.onChange(value)
    }

    render() {
      const { classes, checked, label } = this.props
      return (
        <FormControlLabel
          control={
            <Switch
              checked={checked}
              onChange={this.handleEditModeChange}
              classes={{
                checked: classes.checked,
                bar: classes.bar
              }}
            />
          }
          label={
            label && (
              <Typography color={checked ? 'secondary' : 'textSecondary'}>
                {label}
              </Typography>
            )
          }
        />
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Admin/components/CommonComponents/SwitchToolbarComponent.js